

import React, { useEffect, useState } from "react";
import { load } from "@cashfreepayments/cashfree-js";
import "./Shipping.css";
import { useUserAuth } from "../../Context/UserAuthContext";
import NavBar from "../../components/NavBar/NavBar";
// import toast from "react-hot-toast";
import { toast } from "react-toastify";

import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loaderdots from "../../components/LoaderDots/Loaderdots";

const AddAddress = () => {
  const { user } = useUserAuth();
  const [userAddress, setUserAddress] = useState([])
  const location = useLocation();
  const { pincode } = location.state || { pincode: 'No Pincode Selected' };

  const {totalQuantity, totalPrice} = location.state
  const [formData, setFormData] = useState({
    name: "",
    street: "",
    city: "",
    state: "",
    pinCode: "",
    landmark: "",
    country: "India",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  console.log(selectedAddress)
  const [userCartDetails, setUserCartDetails] = useState([])
  
  const navigate = useNavigate()
  
  const [scheduleDates, setScheduleDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");


  //razorpay
  // function loadScript(src) {
  //   return new Promise((resolve) => {
  //     const script = document.createElement("script");
  //     script.src = src;
  //     script.onload = () => {
  //       resolve(true);
  //     };
  //     script.onerror = () => {
  //       resolve(false);
  //     };
  //     document.body.appendChild(script);
  //   });
  // }

  // useEffect(() => {
  //   loadScript("https://checkout.razorpay.com/v1/checkout.js");
  // }, []);

  // Cashfree integration
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }
  
  useEffect(() => {
    loadScript("https://sdk.cashfree.com/js/v3/cashfree.js");
  }, [])

  useEffect(() => {
    // Generate next week's dates
    const generateScheduleDates = () => {
      const dates = [];
      const today = new Date();
      for (let i = 0; i < 7; i++) {
        const nextDate = new Date(today);
        nextDate.setDate(today.getDate() + i);
        dates.push({
          fullDate: nextDate,
          display: nextDate.toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric",
          }),
        });
      }
      setScheduleDates(dates);
    };
    generateScheduleDates();
  }, []);


  // const handleCheckout = async () => {
  //   setLoading(true);
  //   const cartData = userCartDetails;
  //   console.log(localStorage.getItem("userToken"))
  
  //   try {
  //     const { _id, ...temp } = selectedAddress;
  
  //     // Send request to backend to create an order
  //     const response = await fetch("http://localhost:3002/api/v1/user/orders", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${localStorage.getItem("userToken")}`

  //       },
  //       body: JSON.stringify({
  //         userId: user._id,
  //         orderItems: cartData,
  //         orderShippingInfo: temp,
  //       }),
  //     });
  
  //     const data = await response.json();
  
  //     // Add console log to inspect the backend response
  //     console.log("Backend Response:", data);
  
  //     if (data.message === "Invalid token" || data.message === "Invalid or expired token") {
  //       localStorage.removeItem("userToken");
  //       navigate("/login");
  //       return;
  //     }
  
  //     // if (!response.ok || !data.cashfreeInfo || !data.cashfreeInfo.token || !data.cashfreeInfo.orderId) {
  //     //   toast.error("Failed to initiate payment. Please try again.", {
  //     //     position: "top-right",
  //     //     autoClose: 3000,
  //     //     hideProgressBar: false,
  //     //     closeOnClick: true,
  //     //     pauseOnHover: true,
  //     //     draggable: true,
  //     //     className: "custom-toast",
  //     //   });
  //     //   return;
  //     // }
      


  //     if (!response.ok || !data.cashfreeOrder || !data.cashfreeOrder.payment_session_id || !data.cashfreeOrder.cf_order_id) {
  //       toast.error("Failed to initiate payment. Please try again.", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         className: "custom-toast",
  //       });
  //       return;
  //     }
  
  //     // Add console log to check token and orderId
  //     console.log("Cashfree Token:", data.cashfreeInfo.token);
  //     console.log("Cashfree Order ID:", data.cashfreeInfo.orderId);
  
  //     // Initialize Cashfree payment gateway
  //     const cashfree = new window.Cashfree();
  //     const paymentOptions = {
  //       orderToken: data.cashfreeInfo.token, // Token from backend
  //       orderId: data.cashfreeInfo.orderId, // Order ID from backend
  //       onSuccess: async (paymentData) => {
  //         try {
  //           console.log("Payment Success Data:", paymentData); // Debugging log
  
  //           // Send payment data to backend for verification
  //           const validateResponse = await fetch(
  //             "https://riymay.com/api/v1/user/payments/verify",
  //             {
  //               method: "POST",
  //               headers: {
  //                 "Content-Type": "application/json",
  //                 Authorization: `Bearer ${localStorage.getItem("userToken")}`,
  //               },
  //               body: JSON.stringify(paymentData),
  //             }
  //           );
  
  //           if (!validateResponse.ok) {
  //             throw new Error(
  //               `Payment validation error: ${validateResponse.statusText}`
  //             );
  //           }
  
  //           await validateResponse.json();
  //           navigate("/");
  //         } catch (error) {
  //           console.error("Payment Validation Error:", error); // Debugging log
  //           toast.error("Payment Validation Failed. Please Try Again!", {
  //             position: "top-right",
  //             autoClose: 3000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //             theme: "colored",
  //           });
  //         }
  //       },
  //       onFailure: (error) => {
  //         console.error("Payment Failure:", error); // Debugging log
  //         toast.error(`Payment Failed: ${error.reason}`, {
  //           position: "top-right",
  //           autoClose: 3000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           theme: "colored",
  //         });
  //       },
  //     };
  
  //     cashfree.init(paymentOptions);
  //     cashfree.open();
  //   } catch (error) {
  //     console.error("handleCheckout Error:", error); // Debugging log
  //     toast.error("An error occurred during checkout. Please try again.", {
  //       position: "top-right",
  //       autoClose: 3000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       theme: "colored",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  
  
  
  const handleCheckout = async () => {
    setLoading(true);
    const cartData = userCartDetails;
    console.log(localStorage.getItem("userToken"))
  
    try {
      const { _id, ...temp } = selectedAddress;
  
      // Send request to backend to create an order
      const response = await fetch("https://riymay.com/api/v1/user/orders", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`

        },
        body: JSON.stringify({
          userId: user._id,
          orderItems: cartData,
          orderShippingInfo: temp,
        }),
      });
  
      const data = await response.json();
  
      // Add console log to inspect the backend response
      console.log("Backend Response:", data);
  
      if (data.message === "Invalid token" || data.message === "Invalid or expired token") {
        localStorage.removeItem("userToken");
        navigate("/login");
        return;
      }
  
      if (!response.ok || !data.cashfreeOrder || !data.cashfreeOrder.payment_session_id || !data.cashfreeOrder.cf_order_id) {
        toast.error("Failed to initiate payment. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: "custom-toast",
        });
        return;
      }
      
      // Add console log to check token and orderId
      console.log("Token:", data.cashfreeOrder.payment_session_id);

      const cashfree = await load({ mode: 'production' });

      setLoading(true); // Start loading
     // 2. Start Checkout
     const data2 = await cashfree.checkout({
      paymentSessionId: data.cashfreeOrder.payment_session_id, // Make sure 'data' is available here!
      redirectTarget: "_self",
      returnUrl: "https://riymay.com/payment/status", // Optional if needed later
    })
    .then(async (result) => {
      console.log("Cashfree Checkout Result:", result);

      // 3. If there is an error
      if (result.error) {
        console.error('❌ Payment Failed:', result.error);
        toast.error(`Payment failed: ${result.error.message || "Unknown error"}`);
        return;
      }

      // 4. If payment is successful
      if (result.paymentDetails) {
        console.log("✅ Payment Success:", result.paymentDetails);

        try {
          const verifyRes = await fetch('https://riymay.com/api/v1/user/payments/verify', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            },
            body: JSON.stringify(result.paymentDetails),
          });

          const verificationData = await verifyRes.json();
          console.log("✅ Verification Success:", verificationData);

          toast.success('Payment successful! Your order has been placed.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            className: "custom-toast",
          });

          navigate('/'); // Redirect after success
        } catch (err) {
          console.error('❌ Verification Error:', err);
          toast.error('Payment verification failed.');
        }
      }
    })
    .catch((error) => {
      console.error("Checkout Error:", error);
      toast.error("An error occurred during checkout. Please try again.");
    });

    console.log("Checkout Data Returned:", data2);

  } catch (error) {
    console.error("handleCheckout Error:", error);
    toast.error("An error occurred during checkout. Please try again.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
    });
  } finally {
    setLoading(false); // Always stop loading
  }
};
  
  
  

  useEffect(() => {
      const fetchUser = async() => {
        const response  = await fetch(
           `https://riymay.com/api/v1/user/getuserdetails`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("userToken")}`,
                "Content-Type": "application/json",
              },
            }
        )
  
        if (!response.ok) {          
        toast.success("Failed to fetch user data", {
          autoClose: 3000, // Duration in milliseconds (20 seconds)
        });
          throw new Error("Failed to fetch user data");
        }
        const result = await response.json();
        const temp = result.user.cart.map((eachProduct) => ({...eachProduct, couponCode: eachProduct.coupon}))
        setUserCartDetails(temp)
      }
      fetchUser()
    }, [])

    const handleSelectAddress = (address) => {
      if (selectedAddress?._id === address._id) {
        // If the same address is clicked again, deselect it
        setSelectedAddress(null);
        toast.warning("Address De-selected.", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: "custom-toast",
          bodyClassName: "custom-toast-body",
                    toastId:"AddressDeselected"
        });
      } else {
        // Select a new address
        setSelectedAddress(address);
        toast.success("Address Selected Successfully!", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
         className: "custom-toast",
            bodyClassName: "custom-toast-body",
          toastId:"AddressSelected"
        });
      }
    };
    


  const fetchUserDetails = async() => {
    const response  = await fetch(
       `https://riymay.com/api/v1/user/getuserdetails`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            "Content-Type": "application/json",
          },
        }
    )

    if (!response.ok) {
      throw new Error("Failed to fetch user data");
    }
    const result = await response.json();
    setUserAddress((result.user.shippingAddress
))
  }

  useEffect(() => {
     
      fetchUserDetails()
    }, [])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };


   // Handle Delete Address
   const handleDeleteAddress = async (id) => {
    try {
      await fetch("https://riymay.com/api/v1/user/shipping/remove/address/", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        body: JSON.stringify({addressId :id }),
      });
      fetchUserDetails();
    } catch (err) {
      console.error("Error deleting address:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
  
    const shippingAdress = {
      name: formData.name,
      street: formData.street,
      city: formData.city,
      state: formData.state,
      pinCode: formData.pinCode,
      landmark: formData.landmark,
      country: formData.country
    };
  
    try {
      const response = await fetch("https://riymay.com/api/v1/user/shipping/add/address/", {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("userToken")}`,
      },
      body: JSON.stringify({ shippingAdress }),
      });
  
      if (!response.ok) {
        throw new Error("Failed to add address. Please try again.");
      }
  
      const data = await response.json();
      if (response.ok) {
        setSuccess("Address Added Successfully!");
        toast.success("✅ Address Added Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: "custom-toast",
            bodyClassName: "custom-toast-body",
          toastId:"addedSuccessfully"
        });
        fetchUserDetails();
      } else {
        toast.error("❌ Failed to Add Address. Please Try Again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          toastId:"failedToAdd"
        });
      }
      
  
      setFormData({
        name: "",
        street: "",
        city: "",
        state: "",
        pinCode: "",
        landmark: "",
        country: "India"
      });
    } catch (err) {
      console.error("Error adding address:", err);
      setError(err.message || "An error occurred.");
    } finally {
      setLoading(false);
      setShowModal(false)
    }
  };

 if (loading) return <div><Loaderdots /></div>
  

  return (
    <>
      {/* <NavBar /> */}

      {/* <div className="address-container"></div> */}

      <div className="address-checkout-summary-container">
        <div className="address-showing-container">
          {/* Address Cards */}
          <div className="address-card">
            <h2 className="addresspage-new-title">Manage Addresses</h2>
            <button
              className="addresspage-new-add-button"
              onClick={() => setShowModal(true)}
            >
              + Add New Address
            </button>
          </div>
          {/* <h3>Delivery Address</h3> */}

          {userAddress &&
            userAddress.map((address) => (
              <div
                key={address._id}
                // className="address-card-3"
                onClick={() => handleSelectAddress(address)}

                className={`address-card-3 address-card-heading ${
                  selectedAddress?._id === address._id ? "selected" : ""
                }`}
              >
                {/* <div
                  className={`address-card-heading ${
                    selectedAddress?._id === address._id ? "selected" : ""
                  }`}
                ></div> */}

                <p className="address-card-street">{address.name} </p>
                <p className="address-card-street">{address.street}</p>
                <p className="address-card-city">
                  {address.city}, {address.state} - {address.pinCode}
                </p>
                <p className="address-card-country">{address.country}</p>
                <div className="address-card-buttons">
                  <button
                    className="address-card-delete"
                    onClick={() => handleDeleteAddress(address._id)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
        </div>
        <div className="address-showing-summary">
          <div className="address-showing-sub-summary">
          <h3 className="address-showing-summary-heading">Checkout-Summary:</h3>
          <div className="address-showing-summary-item">
            <div className="address-showing-summary-para">
              <p>Total Quantity:</p> <p> {totalQuantity}</p>
            </div>
            <div className="address-showing-summary-para">
              <p>Total Cart Price:</p>
               <p>₹ {totalPrice}</p>
            </div>
          </div>

          {pincode && pincode !== "N/A" && (
            <div className="custom-delivery-dat">
              <div className="custom-delivery-date">
                <h3>Select a Delivery Date:</h3>
                <div className="delivery-date-tabs">
                  {scheduleDates.map((date) => (
                    <button
                      key={date.fullDate}
                      className={`delivery-date-tab ${
                        selectedDate === date.fullDate.toISOString()
                          ? "selected"
                          : ""
                      }`}
                      onClick={() =>
                        setSelectedDate(date.fullDate.toISOString())
                      }
                    >
                      {date.display}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {pincode && pincode === "N/A" ? (
            <button className="checkout-button" onClick={handleCheckout}>
              Proceed Payment
            </button>
          ) : (
            <button className="checkout-button" onClick={handleCheckout}>
              Place Trail
            </button>
          )}
        </div>
        </div>
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2 className="modal-heading">Add a New Address</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
                className="address-input"
                required
              />
              <input
                type="text"
                name="street"
                value={formData.street}
                onChange={handleChange}
                placeholder="Street Address"
                className="address-input"
                required
              />
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="City"
                className="address-input"
                required
              />
              <select
                name="state"
                value={formData.state}
                onChange={handleChange}
                className="address-select"
                required
              >
                <option value="">Select State</option>
                <option value="AP">Andhra Pradesh</option>
                <option value="AR">Arunachal Pradesh</option>
                <option value="AS">Assam</option>
                <option value="BR">Bihar</option>
                <option value="CG">Chhattisgarh</option>
                <option value="GA">Goa</option>
                <option value="GJ">Gujarat</option>
                <option value="HR">Haryana</option>
                <option value="HP">Himachal Pradesh</option>
                <option value="JH">Jharkhand</option>
                <option value="KA">Karnataka</option>
                <option value="KL">Kerala</option>
                <option value="MP">Madhya Pradesh</option>
                <option value="MH">Maharashtra</option>
                <option value="MN">Manipur</option>
                <option value="ML">Meghalaya</option>
                <option value="MZ">Mizoram</option>
                <option value="NL">Nagaland</option>
                <option value="OD">Odisha</option>
                <option value="PB">Punjab</option>
                <option value="RJ">Rajasthan</option>
                <option value="SK">Sikkim</option>
                <option value="TN">Tamil Nadu</option>
                <option value="TS">Telangana</option>
                <option value="TR">Tripura</option>
                <option value="UP">Uttar Pradesh</option>
                <option value="UK">Uttarakhand</option>
                <option value="WB">West Bengal</option>
                <option value="AN">Andaman and Nicobar Islands</option>
                <option value="CH">Chandigarh</option>
                <option value="DN">Dadra and Nagar Haveli and Daman and Diu</option>
                <option value="DL">Delhi</option>
                <option value="JK">Jammu and Kashmir</option>
                <option value="LA">Ladakh</option>
                <option value="LD">Lakshadweep</option>
                <option value="PY">Puducherry</option>

              </select>
              <input
                type="text"
                name="pinCode"
                value={formData.pinCode}
                onChange={handleChange}
                placeholder="ZIP Code"
                className="address-input"
                required
              />
              <input
                type="text"
                name="landmark"
                value={formData.landmark}
                onChange={handleChange}
                placeholder="Nearest Landmark (optional)"
                className="address-input"
              />
              <select
                name="country"
                value={formData.country}
                onChange={handleChange}
                className="address-select"
              >
                <option value="India">India</option>
              </select>
              <button type="submit" disabled={loading}>
                {loading ? "Adding..." : "Submit"}
              </button>
              <button type="button" onClick={() => setShowModal(false)}>
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default AddAddress;
